import { render, staticRenderFns } from "./Adjustment.vue?vue&type=template&id=017d275c&scoped=true&"
import script from "./Adjustment.vue?vue&type=script&lang=js&"
export * from "./Adjustment.vue?vue&type=script&lang=js&"
import style0 from "./Adjustment.vue?vue&type=style&index=0&id=017d275c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017d275c",
  null
  
)

export default component.exports